import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';

import { BusinessIntelligenceService } from './business-intelligence.service';

@Component({
  selector   : 'bi-dashboard',
  template: require('./business-intelligence.dashboard.component.html')
})
export class BusinessIntelligenceDashboardComponent implements OnInit, OnChanges {
  @Input() dashboardId: any;

  @ViewChild('biFrame', { static: true }) biFrameRef: ElementRef;

  loading = true;

  status: any = {};

  filters: any = {
    end_date  : '',
    start_date: ''
  };

  private bootstrapped = false;

  constructor ( private businessIntelligenceService: BusinessIntelligenceService ) {}

  ngOnInit () : void {
    this.businessIntelligenceService.isReady()
    .then(( status ) => {
      this.status = status;

      const iframe = (this.biFrameRef.nativeElement as HTMLElement).querySelector('iframe');

      return this.businessIntelligenceService.bootstrapFrame(iframe);
    })
    .then(() => {
      this.bootstrapped = true;

      this.loadDashboardById(this.dashboardId);
    })
    .catch(( status : any = {} ) => {
      this.status = status;
    });
  }

  ngOnChanges ( changes : SimpleChanges ) : void {
    if ( changes['dashboardId'] && !changes['dashboardId'].firstChange && this.bootstrapped ) {
      this.loadDashboardById(changes['dashboardId'].currentValue);
    }
  }

  clearFilters () : void {
    this.businessIntelligenceService.clearFilters().then(() => {
      this.filters = {};
    });
  }

  filter () : void {
    this.loading = true;

    this.businessIntelligenceService.filter(this.filters).finally(() => {
      this.businessIntelligenceService.toggleAdvancedFilters();

      this.loading = false;
    });
  }

  isStatus ( status : string | string[] = 'ready' ) : boolean {
    return Array.isArray(status)
      ? status.indexOf(this.status.state) > -1
      : this.status.state === status;
  }

  print () : void {
    (this.biFrameRef.nativeElement as HTMLElement).scrollIntoView(false);

    this.businessIntelligenceService.print();
  }

  toggleAdvancedFilters () : void {
    this.businessIntelligenceService.toggleAdvancedFilters();
  }

  private loadDashboardById ( id : any ) : void {
    if ( id ) {
      this.loading = true;

      this.businessIntelligenceService.loadDashboard(id).finally(() => {
        this.loading = false;
      });
    }
    else {
      this.businessIntelligenceService.hideFrame();
    }
  }
}
